import { useSelector } from 'react-redux'

import { RootState } from '../../../reducers'
import { getStepCountSelector } from '../../../selectors/dialog'

export function useStepCount(dialogId: string) {
  return useSelector<RootState, number>(getStepCountSelector(dialogId))
}
